import { CapacityContributionType } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'noddi-ui-web/src/base';
import { ReactElement } from 'react';
import { CAPACITY_CONTRIBUTION_TYPE_ICON } from '../ServiceWorker/CapacityContributionTypeIcon';
import { formatSlotCapacitySummary, type SlotCapacityInfo } from './slotCapacityInfo';

type Props = {
  capacity: SlotCapacityInfo;
  enabled: boolean;
  children: ReactElement;
};

export const SlotCapacityTooltip = ({ capacity, enabled, children }: Props) => {
  if (!enabled) {
    return children;
  }

  const capacitySummary = formatSlotCapacitySummary(capacity);

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          side='top'
          className='max-w-xs border border-border bg-white px-3 py-2 text-left text-xs text-foreground shadow-md'
        >
          <div className='flex flex-col gap-1'>
            <p className='font-medium text-muted-foreground'>{capacitySummary}</p>
            {capacity.contributions.length > 0 && (
              <ul className='flex flex-col gap-1'>
                {capacity.contributions.map((contribution) => {
                  const type = contribution.contributionType ?? CapacityContributionType.PERSONAL;
                  return (
                    <li key={contribution.id} className='flex items-start gap-1 leading-snug'>
                      <NoddiIcon
                        name={CAPACITY_CONTRIBUTION_TYPE_ICON[type]}
                        size='xSmall'
                        className='mt-0.5 shrink-0'
                      />
                      <span>
                        <span className='font-medium'>{contribution.name}</span>
                        {contribution.capabilityNames.length > 0 && (
                          <span className='text-muted-foreground'>
                            {' · '}
                            {contribution.capabilityNames.join(', ')}
                          </span>
                        )}
                      </span>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
